import {
  CardCvcElement as StripeCvcElement,
  CardExpiryElement as StripeExpiryElement,
  CardNumberElement as StripeNumberElement
} from '@stripe/react-stripe-js';

import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement
} from 'payments/components/CardElements';
import {
  CloverCardField,
  StripeCardField
} from 'payments/components/CardField';
import { CommerceHubCardField } from 'payments/components/commerceHub/CommerceHubCardField';
import { PaymentProviders } from 'payments/constants/providers';
import { usePaymentProvider } from 'payments/hooks/usePayments';

export const useCardFields = () => {
  let CardField = null;
  let NumberElement = null;
  let ExpiryElement = null;
  let CvcElement = null;
  let isClover = false;
  let isCommerceHub = false;
  let isStripe = false;
  const paymentProvider = usePaymentProvider();

  switch (paymentProvider) {
    case PaymentProviders.CLOVER:
      CardField = CloverCardField;
      NumberElement = CardNumberElement;
      ExpiryElement = CardExpiryElement;
      CvcElement = CardCvcElement;
      isClover = true;
      break;
    case PaymentProviders.COMMERCE_HUB:
      CardField = CommerceHubCardField;
      NumberElement = CardNumberElement;
      ExpiryElement = CardExpiryElement;
      CvcElement = CardCvcElement;
      isCommerceHub = true;
      break;
    case PaymentProviders.STRIPE:
      CardField = StripeCardField;
      NumberElement = StripeNumberElement;
      ExpiryElement = StripeExpiryElement;
      CvcElement = StripeCvcElement;
      isStripe = true;
      break;
    default:
  }

  return {
    CardField,
    NumberElement,
    ExpiryElement,
    CvcElement,
    isClover,
    isCommerceHub,
    isStripe
  };
};
